import React from "react";
import { connect } from "react-redux";
import { setLoader } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";

class AccountPersonalDetailsPage extends React.Component {
  componentDidMount = () => {
    // No need to fetch cart - we get customer data from localStorage/auth
    this.props.setLoader(false, null);
  }

  renderPersonalDetails = () => {
    // Get customer data from localStorage or auth state
    const firstname = localStorage.first_name || this.props.auth?.first_name || '';
    const lastname = localStorage.last_name || this.props.auth?.last_name || '';
    const email = localStorage.email || this.props.auth?.email || '';
    const mobile = localStorage.mobile || this.props.auth?.mobile || '';

    return (
      <React.Fragment>
        <h2 className="h2">Name</h2>
        <div>{firstname} {lastname}</div>
        <h2 className="h2">Email</h2>
        <div>{email || 'Not set'}</div>
        <h2 className="h2">Mobile</h2>
        <div>{mobile || 'Not set'}</div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div id="page-account-personal-details">
        <AccountNav />
        <div id="account-content">
          <h1 className="h1">Personal Details</h1>  
          <div id="account-personal-details">
            {this.renderPersonalDetails()} 
          </div>
        </div>
      </div>
      
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default requireAuth(
  connect(
    mapStateToProps,
    { setLoader }
  )(AccountPersonalDetailsPage)
);
